import { NoPermissionMessage } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.contants';
import { IHashmapItemWithCustomProps } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { Props as PhasePerformanceBreakdownProps } from 'components/widgets/PhasePerformanceBreakdown/PhasePerformanceBreakdown';

export const phasePerformanceBreakdown: IHashmapItemWithCustomProps<PhasePerformanceBreakdownProps> = {
    titleWithoutProjectAndContract: 'Phase Performance Breakdown',
    NoPermissionMessage,
    permission: 'PortfolioPage',
};
